module.exports = __webpack_public_path__ + "img/penny-arcade.13a51331.svg";